import BenefitTypeRepository from '@/shared/http/repositories/socialProject/benefit-type'
import BreadCrumb from '@/components/layout/BreadCrumb/breadCrumb.vue'
import NewRegister from '@/components/layout/NewRegister/newRegister.vue'
import BenefitType from '@/shared/models/benefitType'
import { IsSuccessCode } from '@/shared/utils/API'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'EditarTipoDeBeneficio',

  components: {
    [BreadCrumb.name]: BreadCrumb,
    [NewRegister.name]: NewRegister
  },

  data: () => ({
    placeholder: 'Nome',
    title: 'Tipo de Beneficio',
    benefitType: new BenefitType(),
    isNew: false
  }),

  computed: {
    breadCrumb() {
      return {
        breadcrumbItems: [
          {
            text: 'Dashboard',
            href: this.$router.resolve({ name: 'Dashboard' }).href
          },
          {
            text: 'Tipos de benefício',
            href: this.$router.resolve({ name: 'BenefitType' }).href
          },
          {
            text: 'Editar tipo de benefício',
            active: true
          }
        ]
      }
    }
  },

  created() {
    this.getById()
  },

  methods: {
    getById() {
      loading.push()
      BenefitTypeRepository.GetById(this.$route.params.id)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.benefitType = res.data.data
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao carregar tipo de benefício', 'ERRO')
        })
    },

    update(benefitType) {
      loading.push()
      BenefitTypeRepository.Update(benefitType)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()
  
          loading.pop()
          toast.success('Tipo de Benefício editado com sucesso', 'EDITAR TIPO DE BENEFÍCIO')
          Promise.resolve()
          return this.$router.replace({ name: 'BenefitType' })
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao editar tipo de benefício', 'ERRO')
        })
    }    
  }
}
